import { get, post } from '../baseService'
import { EventModel } from 'app/models/newDelegation/eventModel'
import { CountryModel } from 'app/models/timesheet/countryModel'
import { AllowanceModel } from 'app/models/newDelegation/allowanceModel'
import { AccomodationModel } from 'app/models/newDelegation/accomodationModel'
import { InvoiceModel } from 'app/models/newDelegation/invoiceModel'
import { AdvancePaymentModel } from 'app/models/newDelegation/advancePaymentModel'
import { ExchangeRateModel } from 'app/models/newDelegation/exchangeRateModel'
import { SERVICE_DATE_FORMAT } from 'app/constants/date'

const create = (): any => {
  const getBusinessTrips = (
    companyId: string,
    drivers: Array<string>,
    startTime: string,
    endTime: string,
    filter: number,
    onlyPolish: boolean,
  ) =>
    post(
      `api/${companyId}/businesstrip/trips`,
      {
        drivers,
        startTime,
        endTime,
        filter,
        onlyPolish,
      },
      false,
    )

  const getBusinessTripDetails = (companyId: string, id: string) =>
    get(`api/${companyId}/businesstrip/details?&id=${id}`, false)

  const getCountries = (companyId: string) =>
    get(`api/${companyId}/country/countries`, false)

  const getGpsData = (
    companyId: string,
    driverId: string,
    startTime: string,
    endTime: string,
  ) =>
    get(
      `api/${companyId}/businesstrip/gpsData?&driverId=${driverId}&startTime=${startTime}&endTime=${endTime}`,
      false,
    )

  const getVehicleGpsData = (
    companyId: string,
    vehicleId: string,
    startTime: string,
    endTime: string,
  ) =>
    get(
      `api/${companyId}/businesstrip/vehicleGpsData?&vehicleId=${vehicleId}&startTime=${startTime}&endTime=${endTime}`,
      false,
    )

  const getTmsData = (
    companyId: string,
    driverId: string,
    startTime: string,
    endTime: string,
  ) =>
    get(
      `api/${companyId}/businesstrip/tmsData?&driverId=${driverId}&startTime=${startTime}&endTime=${endTime}`,
      false,
    )

  const getGpsFromTachograph = (
    companyId: string,
    driverId: string,
    startTime: string,
    endTime: string,
  ) =>
    get(
      `api/${companyId}/businesstrip/gpsFromTachograph?&driverId=${driverId}&startTime=${startTime}&endTime=${endTime}`,
      false,
    )

  const getCountriesWithMinimalPayment = (companyId: string) =>
    get(
      `api/${companyId}/businesstrip/minimalPaymentCountries`,
      false,
    )

  const getCurrencies = (companyId: string) =>
    get(`api/${companyId}/businesstrip/currencies`, false)

  const getMultipleDestinationCountries = (companyId: string) =>
    get(
      `api/${companyId}/businesstrip/setMultipleDestinationCountries`,
      false,
    )

  const generateTripNumber = (
    companyId: string,
    driverId: string,
    country: CountryModel,
    events: Array<EventModel>,
  ) =>
    post(
      `api/${companyId}/businesstrip/generateNumber`,
      {
        companyId,
        driverId,
        country,
        events,
      },
      false,
    )

  const generateAccomodations = (
    companyId: string,
    driverId: string,
    exchangeRateDate: string,
    country: CountryModel,
    events: Array<EventModel>,
    invoices: Array<InvoiceModel>,
    stopDownloadingRates: boolean,
  ) =>
    post(
      `api/${companyId}/businesstrip/generateAccomodations`,
      {
        companyId,
        driverId,
        exchangeRateDate,
        country,
        events,
        invoices,
        stopDownloadingRates,
      },
      false,
    )

  const generateAllowances = (
    companyId: string,
    driverId: string,
    exchangeRateDate: string,
    country: CountryModel,
    events: Array<EventModel>,
    alimentations: Array<AllowanceModel>,
    invoices: Array<InvoiceModel>,
    stopDownloadingRates: boolean,
  ) =>
    post(
      `api/${companyId}/businesstrip/generateAlimentations`,
      {
        companyId,
        driverId,
        exchangeRateDate,
        country,
        events,
        alimentations,
        invoices,
        stopDownloadingRates,
      },
      false,
    )

  const deleteBusinessTrips = (companyId: string, ids: string[]) =>
    Promise.all(
      ids.map((id) =>
        post(`api/${companyId}/businesstrip/delete`, { id }, false),
      ),
    )

  const getDates = (
    companyId: string,
    exchangeRateDate: string,
    calculationDate: string,
    events: Array<EventModel>,
    onlyExchangeRateDate: boolean,
  ) =>
    post(
      `api/${companyId}/businesstrip/dates`,
      {
        companyId,
        exchangeRateDate,
        calculationDate,
        events,
        onlyExchangeRateDate,
      },
      false,
    )

  const save = (
    companyId: string,
    id: string,
    driverId: string,
    exchangeRateDate: string,
    calculationDate: string,
    settlementMonth: string,
    country: CountryModel,
    number: string,
    purpose: string,
    isSettled: boolean,
    doNotConvertCurrencies: boolean,
    events: Array<EventModel>,
    allowances: Array<AllowanceModel>,
    accomodations: Array<AccomodationModel>,
    invoices: Array<InvoiceModel>,
    advancePayments: Array<AdvancePaymentModel>,
    alimentations: Array<AllowanceModel>,
    isAccomodationModifiedByUser: boolean,
    isDestinationCountryModifiedByUser: boolean,
    force: boolean,
    forceWithoutExchangeRates: boolean,
    withPreviousExchangeRateDate: boolean,
    forceCopyToCoDriver: boolean,
    copyToCoDriver: boolean,
    checkedTripCoDrivers: Array<boolean>,
  ) =>
    post(
      `api/${companyId}/businesstrip/save`,
      {
        companyId,
        id,
        driverId,
        exchangeRateDate,
        calculationDate,
        settlementMonth,
        country,
        number,
        purpose,
        isSettled,
        doNotConvertCurrencies,
        events,
        allowances,
        accomodations,
        invoices,
        advancePayments,
        alimentations,
        isAccomodationModifiedByUser,
        isDestinationCountryModifiedByUser,
        force,
        forceWithoutExchangeRates,
        withPreviousExchangeRateDate,
        forceCopyToCoDriver,
        copyToCoDriver,
        checkedTripCoDrivers,
      },
      false,
    )

  const saveGrouped = (
    companyId: string,
    id: string,
    driverId: string,
    defaultStartDate: string,
    country: CountryModel,
    events: Array<EventModel>,
    force: boolean,
    withPreviousExchangeRateDate: boolean,
    forceCopyToCoDriver: boolean,
    copyToCoDriver: boolean,
    checkedTripCoDrivers: Array<boolean>,
  ) =>
    post(
      `api/${companyId}/businesstrip/saveGrouped`,
      {
        companyId,
        id,
        driverId,
        defaultStartDate,
        country,
        events,
        force,
        withPreviousExchangeRateDate,
        forceCopyToCoDriver,
        copyToCoDriver,
        checkedTripCoDrivers,
      },
      false,
    )

  const generateTrips = (
    companyId: string,
    driverId: string,
    defaultStartDate: string,
    defaultEndDate: string,
    events: Array<EventModel>,
    generationMode: number,
  ) =>
    post(
      `api/${companyId}/businesstrip/generateTrips`,
      {
        companyId,
        driverId,
        defaultStartDate,
        defaultEndDate,
        events,
        generationMode,
      },
      false,
    )

  const updateExchangeRates = (
    companyId: string,
    driverId: string,
    exchangeRateDate: string,
    accomodations: Array<AccomodationModel>,
    invoices: Array<InvoiceModel>,
    advancePayments: Array<AdvancePaymentModel>,
  ) =>
    post(
      `api/${companyId}/businesstrip/updateExchangeRates`,
      {
        companyId,
        driverId,
        exchangeRateDate,
        accomodations,
        invoices,
        advancePayments,
      },
      false,
    )

  const getExchangeRate = (companyId, exchangeRateDate, currencyCode) =>
    get(
      `api/${companyId}/businesstrip/exchangeRate?&exchangeRateDate=${exchangeRateDate}&currencyCode=${currencyCode}`,
      false,
    )

  const changeExchangeRates = (
    companyId: string,
    rates: Array<ExchangeRateModel>,
  ) =>
    post(
      `api/${companyId}/businesstrip/changeExchangeRate`,
      {
        companyId,
        rates: rates.map((r) => {
          return {
            exchangeRateDate: r.exchangeRateDate.format(SERVICE_DATE_FORMAT),
            currencyCode: r.currencyCode,
            rate: r.rate,
          }
        }),
      },
      false,
    )

  return {
    getBusinessTrips,
    getCountries,
    getCurrencies,
    generateTripNumber,
    getExchangeRate,
    changeExchangeRates,
    generateAccomodations,
    generateAllowances,
    getMultipleDestinationCountries,
    save,
    deleteBusinessTrips,
    getBusinessTripDetails,
    getDates,
    updateExchangeRates,
    getCountriesWithMinimalPayment,
    getGpsData,
    getVehicleGpsData,
    getTmsData,
    getGpsFromTachograph,
    saveGrouped,
    generateTrips,
  }
}

export default {
  create,
}
